import { render, staticRenderFns } from "./Transportacion.vue?vue&type=template&id=90b123b8"
import script from "./Transportacion.vue?vue&type=script&lang=js"
export * from "./Transportacion.vue?vue&type=script&lang=js"
import style0 from "./Transportacion.vue?vue&type=style&index=0&id=90b123b8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports